"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneNumberText = PhoneNumberText;
exports.PrimaryText = PrimaryText;
exports.SecondaryText = SecondaryText;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"];
function PrimaryText(_ref) {
  var className = _ref.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('text-2xl font-bold text-dark', className)
  }, rest));
}
function SecondaryText(_ref2) {
  var className = _ref2.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('text-sm font-semibold pt-2 pb-8 whitespace-pre-line text-gray-medium', className)
  }, rest));
}
function PhoneNumberText(_ref3) {
  var className = _ref3.className,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('text-2xl text-primary font-bold', className)
  }, rest));
}
//# sourceMappingURL=Text.js.map